export const minYear = (value: string, minYear: number | 'currentYear') => {
    return parseFloat(value) >= (minYear === 'currentYear' ? new Date().getFullYear() : minYear);
};

export const maxYear = (value: string, maxYear: number | 'currentYear') => {
    return parseFloat(value) <= (maxYear === 'currentYear' ? new Date().getFullYear() : maxYear);
};
